import { EVENTS } from '../../../../../library';

export const LOG_EVENT_PATH = (event) => {
  return EVENTS.VIEWS.APP.SETTINGS.USER[event];
};

export const TRANSLATION_PATH = (route) => {
  return `views.app.settings.user.${route}`;
};
